<template>
  <div v-if="shouldRenderConfig" :class="getClassName">
    <!-- <div class="matrix_inputQuantityLabel">{{ $t(name) }}</div> -->
    <div class="matrix_inputQuantityInput">
      <input
        v-model="quantity"
        type="number"
        class="form-control"
        :placeholder="$t(name)"
        @keydown.enter="onQuantityEnter"
      />
      <button type="button" class="btn btn-primary" @click="onQuantityEnter">
        <img :src="getBaseUrl + `images/matrix/white_plus_2.svg`" />
      </button>
    </div>
  </div>
</template>
<script>
import { useCustomStore } from "@/stores/modules/custom";
import { useChangeOptionsStore } from "@/stores/modules/changeOptions";
import { useWebproductStore } from "@/stores/modules/webproduct";
import { useUrlsStore } from "@/stores/modules/urls.js";
import { mapState, mapActions } from "pinia";

import { i18n } from "../../i18n.js";

export default {
  data: function () {
    return {
      quantity: null
    };
  },
  computed: {
    ...mapState(useUrlsStore, ["getBaseUrl"]),
    ...mapState(useChangeOptionsStore, ["getQuantitiesValuesWithCode"]),
    ...mapState(useCustomStore, ["getInputQuantityMinMax"]),
    ...mapState(useWebproductStore, ["getPackingUnit", "getSweetAlert"]),
    name: () => {
      return "Custom quantity:";
    }
  },
  methods: {
    ...mapActions(useCustomStore, ["setCustomQuantity"]),
    ...mapActions(useChangeOptionsStore, ["setQuantity"]),
    onQuantityEnter: function (event) {
      if (event) event.preventDefault();
      const active_qty = this.quantity;
      const qty_line = this.getQuantitiesValuesWithCode.find(el => {
        return parseInt(el.qty) == parseInt(active_qty);
      });
      if (qty_line) {
        // set the qty as selected
        this.setQuantity({ qty: qty_line.qty, qtyCode: qty_line.qtyCode });
        return;
      }

      var isNum = /^\d+$/.test(this.quantity);
      if (!isNum) {
        this.getSweetAlert({
          text: i18n.t("Please enter a valid number !"),
          icon: "warning"
        });
        return;
      }

      var intQty = parseInt(this.quantity);

      var minMax = this.getInputQuantityMinMax;
      if (minMax.min && minMax.min > intQty) {
        this.getSweetAlert({
          text: i18n.t("Quantity should be bigger than or equal to {min}", {
            min: minMax.min
          }),
          icon: "warning"
        });
        return;
      }
      if (minMax.max && minMax.max < intQty) {
        this.getSweetAlert({
          text: i18n.t("Quantity should be lower than or equal to {max}", {
            max: minMax.max
          }),
          icon: "warning"
        });
        return;
      }
      if (intQty == 0) {
        this.getSweetAlert({
          text: i18n.t("Quantity should be bigger than 0"),
          icon: "warning"
        });
        return;
      }
      if (intQty % this.getPackingUnit !== 0) {
        this.getSweetAlert({
          text: i18n.t("The quantity must divide by {packUnit}!", {
            packUnit: this.getPackingUnit
          }),
          icon: "warning"
        });
        return;
      }

      this.setCustomQuantity(intQty);
    }
  }
};
</script>
